import './components/accordion';
import './components/archive-hero';
import './components/sliders';
import './components/information-bar';
import './components/single-product';
import './components/quantity';
import './components/checkout';
import './components/sticky-menu';
import './components/anchor-links';
import './modules/newsletter';
import './modules/faq';
import MiniCart from './components/mini-cart';
import objectFitImages from 'object-fit-images';
require( 'imagelightbox/dist/imagelightbox.min.js' );

jQuery( $ => {
	require( './ac-mobile-menu' );

	// Components
	const miniCart = document.querySelector( '.widget_shopping_cart' );
	if ( miniCart ) {
		new MiniCart();
	}

	$( '[data-search-toggle]' ).on( 'click', function() {
		$( this ).toggleClass( 'search-open' );

		$( this ).attr( 'aria-expanded', ( i, attr ) => {
			return 'true' === attr ? 'false' : 'true';
		} );

		$( '#search-container' ).slideToggle( 150, function() {
			$( this ).find( '.form-control' ).focus();
		} );
	} );

	/**
	 * Generic back button functionality.
	 */
	$( '.js-back-button' ).click( e => {
		e.preventDefault();
		// Equal to clicking the back button in the browser.
		window.history.back();
	} );

	/**
	 * Object fit imaegs for ie11
	 */
	objectFitImages();

	/**
	 * Lightbox
	 */
	$( 'a[data-imagelightbox="gallery"]' ).imageLightbox( {
		overlay: true,
		button: true,
		fullscreen: true,
		navigation: true,
		arrows: true,
	} );

	$( 'a[data-imagelightbox="slider"]' ).imageLightbox( {
		overlay: true,
		button: true,
		fullscreen: true,
		navigation: true,
		arrows: true,
	} );
} );
